import {
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

export class InfoWidgetConfig {
  component: Type<InformationWidgetComponent>;
}

// is used as a factory for project-related widgets. Stands here for one unique selector to be used in shared cross-project components
@Component({
  selector: 'information-widget',
  template: '<ng-template #widget></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InformationWidgetComponent {

  @ViewChild('widget', { read: ViewContainerRef }) widgetEl: ViewContainerRef;

  constructor(
    private _config: InfoWidgetConfig,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _viewContainerRef: ViewContainerRef
  ) {}

  ngAfterViewInit(): void {
    const comp = this._componentFactoryResolver.resolveComponentFactory(this._config.component);

    this.widgetEl.clear();
    const ref = this.widgetEl.createComponent(comp);
    ref.changeDetectorRef.detectChanges();
  }
}
